import Course from "./Course/Route";
import Attendance from "./Attendance/Route";
import Ipft from "./Ipft/Route";
import IpftUsers from "./IpftUsers/Routes";
import Ret from "./Ret/Route/index.js";
import PracticeRet from "./PracticeRet/Route";
import SpeedMarch from "./SpeedMarch/Route";
import Reports from "./Reports/Route";
import GrenadeFiring from "./GrenadeFiring/Route";
import Written from "./Trg/Written";
import WrittenDetail from "./Trg/Detail";
import ExamItem from "./Trg/ExamItem";
import GroupTraining from "./GroupTraining/Route";
import CareerPlan from "./CareerPlan/Route";
import CareerPlanItem from "./CareerPlanItem/Route";

export default [
    ...Attendance,
    ...Course,
    ...Ipft,
    ...Ret,
    ...PracticeRet,
    ...SpeedMarch,
    ...Reports,
    ...IpftUsers,
    ...GrenadeFiring,
    ...Written,
    ...WrittenDetail,
    ...ExamItem,
    ...GroupTraining,
    ...CareerPlan,
    ...CareerPlanItem,
];
